import React, { useState, useRef, useEffect } from 'react';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';

import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
import { useStoreContext } from '../../App/StoreProvider';
import './Inventory.scss';
import { Alert, Col, Dropdown, Modal, OverlayTrigger, Table } from 'react-bootstrap';
import { GET_BOXES, GET_SET_UP } from '../../../graphql/client/queries';
import { useMutation, useQuery } from '@apollo/client/react';
import Row from 'react-bootstrap/Row';
import { CustomButton, Error, Loading, Textfield } from '../../_common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetBoxes_getBoxes_boxDetails as BoxDetails } from '../../../types/schemaTypes';
import {NumericFormat as NumberFormat} from 'react-number-format';
import { CONFIGURE_INVENTORY, DNU_OPERATE, MOVE_BOXES } from '../../../graphql/client/mutations';


interface SetUpModalProps {
    showSetUpModal: boolean;
    setShowSetUpModal: React.Dispatch<React.SetStateAction<boolean>>;
    row: number;
    column: number;
    mutationLoading: boolean;
    modalError: string;
    setModalError: React.Dispatch<React.SetStateAction<string>>;
    handleOnSetUp: (rowCount, columnCount) => void;
}

const SetUpModal = ({
    showSetUpModal,
    setShowSetUpModal,
    row,
    column,
    mutationLoading,
    modalError,
    setModalError,
    handleOnSetUp,
}: SetUpModalProps): React.ReactElement => {
    const [rowCount, setRowCount] = useState<number | undefined>(row);
    const [columnCount, setColumnCount] = useState<number | undefined>(column);

    const [rowError, setRowError] = useState('');
    const [colError, setColError] = useState('');

    const handleOnChangeInput = (inputType, value) => {
        setModalError('');
        if (inputType === 'row' && Number.isNaN(value)) {
            setRowError('Enter a valid number');
            setRowCount(undefined);
        }
        if (inputType === 'column' && Number.isNaN(value)) {
            setColError('Enter a valid number');
            setColumnCount(undefined);
        }
        if (inputType === 'row' && value <= 26) {
            setRowError('');
            setRowCount(value);
        }
        if (inputType === 'row' && value > 26) {
            setRowError('Row should not be more than 26');
        }
        if (inputType === 'column' && value <= 26) {
            setColError('');
            setColumnCount(value);
        }
        if (inputType === 'column' && value > 26) {
            setColError('Column should not be more than 26');
        }
    };

    const onClickClose = () => {
        setRowCount(undefined);
        setColumnCount(undefined);
        setShowSetUpModal(false);
    };

    const onClickSave = () => {
        if (rowCount && rowCount > 0 && columnCount && columnCount > 0) {
            handleOnSetUp(rowCount, columnCount);
        }
    };

    return (
        <Modal show={showSetUpModal} onHide={onClickClose} dialogClassName="Inventory-Setup-Container">
            <Modal.Header className="Inventory-Setup-Header">
                <Modal.Title className="Inventory-Setup-Header-Container">
                    <button className="material-icons Inventory-Setup-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="Inventory-Setup-Title">Inventory Setup</div>
                    <div className="Inventory-Setup-Error">{modalError}</div>
                </Modal.Title>
            </Modal.Header>

            {mutationLoading ? (
                <div className="Inventory-Setup-Spinner">
                    <Loading />
                </div>
            ) : (
                ''
            )}

            <Modal.Body>
                <Row>
                    <Col md={6}>
                        <Textfield
                            label="Number of Rows &rarr;"
                            value={rowCount}
                            onChange={element => handleOnChangeInput('row', parseInt(element.target.value))}
                        />
                        <div className="Inventory-Setup-Error">{rowError}</div>
                    </Col>
                    <Col md={6}>
                        <Textfield
                            label="Number of Columns &uarr;"
                            value={columnCount}
                            onChange={element => handleOnChangeInput('column', parseInt(element.target.value))}
                        />
                        <div className="Inventory-Setup-Error">{colError}</div>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer className="Inventory-Setup-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                <CustomButton
                    title="Save"
                    onClick={onClickSave}
                    isDisabled={!rowCount || !columnCount || rowError.length !== 0 || colError.length !== 0}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default SetUpModal;
